import * as Yup from 'yup'
import { EmailRegex } from '../../../../utils/regexTypes'

export const SubscribeSchema = Yup.object().shape({
  email: Yup.string()
    .email('Email no válido')
    .matches(EmailRegex, 'Email no válido')
    .required('Ingrese un email'),
})
